import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IncludedSeats } from 'pricing-pages-ui-components/seats/IncludedSeats';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicMerchCardSeats = ({
  card,
  currencyCode,
  isPerSeat,
  additionalSeatPrice
}) => {
  var _card$packagedQuantit, _card$packagedQuantit2, _card$packagedQuantit3, _card$packagedQuantit4, _card$packagedQuantit5, _card$packagedQuantit6, _card$packagedQuantit7, _card$packagedQuantit8;
  const totalSeats = ((_card$packagedQuantit = card.packagedQuantitiesMap['CORE_SEAT']) !== null && _card$packagedQuantit !== void 0 ? _card$packagedQuantit : 0) + ((_card$packagedQuantit2 = card.packagedQuantitiesMap['SALES_SEAT']) !== null && _card$packagedQuantit2 !== void 0 ? _card$packagedQuantit2 : 0) + ((_card$packagedQuantit3 = card.packagedQuantitiesMap['SERVICE_SEAT']) !== null && _card$packagedQuantit3 !== void 0 ? _card$packagedQuantit3 : 0) + ((_card$packagedQuantit4 = card.packagedQuantitiesMap['COMMERCE_SEAT']) !== null && _card$packagedQuantit4 !== void 0 ? _card$packagedQuantit4 : 0);
  if (isPerSeat || totalSeats < 1) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-125",
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(IncludedSeats, {
            includedCoreSeats: (_card$packagedQuantit5 = card.packagedQuantitiesMap['CORE_SEAT']) !== null && _card$packagedQuantit5 !== void 0 ? _card$packagedQuantit5 : 0,
            includedSalesSeats: (_card$packagedQuantit6 = card.packagedQuantitiesMap['SALES_SEAT']) !== null && _card$packagedQuantit6 !== void 0 ? _card$packagedQuantit6 : 0,
            includedServiceSeats: (_card$packagedQuantit7 = card.packagedQuantitiesMap['SERVICE_SEAT']) !== null && _card$packagedQuantit7 !== void 0 ? _card$packagedQuantit7 : 0,
            includedCommerceSeats: (_card$packagedQuantit8 = card.packagedQuantitiesMap['COMMERCE_SEAT']) !== null && _card$packagedQuantit8 !== void 0 ? _card$packagedQuantit8 : 0
          })
        })
      })
    }), additionalSeatPrice !== undefined && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "publicPricingPage.merchCard.seats.additionalSeatsStartAt",
          options: {
            price: /*#__PURE__*/_jsx(PriceDisplay, {
              price: additionalSeatPrice,
              currencyCode: currencyCode
            })
          }
        })
      })
    })]
  });
};